import React, { Component } from "react";
import {
    Paper, Typography, Table, TableHead, TableBody, TableRow, TableCell,
    Button, CircularProgress, Box, Grid, AppBar, Toolbar, IconButton,
    Tabs, Tab, TextField, Pagination, InputAdornment
} from "@mui/material";
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import SearchIcon from '@mui/icons-material/Search';
import Cookies from "universal-cookie";
import host from '../../assets/js/Host';
import axios from 'axios';

const cookies = new Cookies();

export default class DeviceTables extends Component {
    state = {
        loading: true,
        bills: [],
        activeTab: 0,
        page: 1,
        totalPages: 1,
        total: 0,
        search: ''
    };

    componentDidMount() {
        this.fetchData('new', 1, '');
    }

    fetchData = (reg, page, search) => {
        this.setState({ loading: true });
        
        const header = {
            "Content-Type": "application/x-www-form-urlencoded",
            token: cookies.get("token")
        };

        axios.get(host + `users/sana/lists/all?reg=${reg}&page=${page}&search=${search}`, { headers: header })
            .then(res => {
                this.setState({ 
                    bills: res.data.bills, 
                    loading: false,
                    page: res.data.page,
                    totalPages: res.data.totalPages,
                    total: res.data.total
                });
            }).catch(error => {
                console.log(error.response);
                this.setState({ loading: false });
            });
    };

    handleTabChange = (event, newValue) => {
        this.setState({ activeTab: newValue, page: 1, search: '' });
        const reg = newValue === 0 ? 'new' : 'return';
        this.fetchData(reg, 1, '');
    };

    handlePageChange = (event, value) => {
        this.setState({ page: value });
        const reg = this.state.activeTab === 0 ? 'new' : 'return';
        this.fetchData(reg, value, this.state.search);
    };

    handleSearchChange = (event) => {
        this.setState({ search: event.target.value });
    };

    handleSearch = () => {
        const reg = this.state.activeTab === 0 ? 'new' : 'return';
        this.fetchData(reg, 1, this.state.search);
    };

    handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            this.handleSearch();
        }
    };

    handleClearSearch = () => {
        this.setState({ search: '' });
        const reg = this.state.activeTab === 0 ? 'new' : 'return';
        this.fetchData(reg, 1, '');
    };

    handleDetailsClick = (billId) => {
        window.location.href = `/sana?id=${billId}`;
    };

    handleBackClick = () => {
        window.history.back();
    };

    renderTable = (bill) => {
        const isReturn = bill.title === "رواجع";
        const label = isReturn ? "رواجع" : "قائمة جديدة";

        const totalDevices = bill.item.reduce((acc, cur) => acc + cur.count, 0);
        const totalRemaining = bill.item.reduce((acc, cur) => acc + (cur.count - cur.count_check), 0);

        return (
            <Grid item xs={12} md={6} lg={4} key={bill.id}>
                <Paper
                    elevation={3}
                    sx={{
                        padding: 2,
                        margin: 1,
                        borderRadius: 2,
                        transition: "transform 0.3s, box-shadow 0.3s, border 0.3s",
                        border: "2px solid transparent",
                        '&:hover': {
                            transform: "scale(1.02)",
                            boxShadow: 6,
                            border: "2px solid #2196f3"
                        }
                    }}
                >
                    <Box display="flex" justifyContent="space-between" alignItems="flex-start">
                        <Box textAlign="right">
                            <Typography variant="subtitle1" color="primary" fontWeight="bold">
                                رقم القائمة: {bill.id}
                            </Typography>
                            <Typography variant="h6" sx={{ color: isReturn ? "red" : "blue", fontWeight: "bold" }}>
                                النوع: {label}
                            </Typography>
                        </Box>

                        <Box textAlign="left">
                            <Typography fontSize={18} fontWeight="bold" color="green">
                                العدد الكلي: {totalDevices}
                            </Typography>
                            <Typography fontSize={18} fontWeight="bold" sx={{ color: "#f1c40f" }} mt={1}>
                                المتبقي: {totalRemaining}
                            </Typography>
                        </Box>
                    </Box>

                    <Box style={{ height: 200, overflowY: "auto", marginTop: 15 }}>
                        <Table size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell>اسم الجهاز</TableCell>
                                    <TableCell align="center">العدد الكلي</TableCell>
                                    <TableCell align="center">تم فحصه</TableCell>
                                    <TableCell align="center">المتبقي</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {bill.item.map((row, index) => (
                                    <TableRow key={index}>
                                        <TableCell>{row.name}</TableCell>
                                        <TableCell align="center">{row.count}</TableCell>
                                        <TableCell align="center">{row.count_check}</TableCell>
                                        <TableCell align="center">{row.count - row.count_check}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </Box>

                    <Box textAlign="left" marginTop={2}>
                        <Button
                            variant="contained"
                            color="secondary"
                            onClick={() => this.handleDetailsClick(bill.id)}
                        >
                            تفاصيل
                        </Button>
                    </Box>
                </Paper>
            </Grid>
        );
    };

    render() {
        const { loading, bills, activeTab, page, totalPages, total, search } = this.state;

        return (
            <Box dir="rtl" sx={{ backgroundColor: "#f5f5f5", minHeight: "100vh" }}>
                <AppBar position="static" sx={{ backgroundColor: "#000" }}>
                    <Toolbar sx={{ display: "flex", justifyContent: "center", position: "relative" }}>
                        <Typography variant="h6" sx={{ textAlign: "center", flexGrow: 1 }}>
                            القوائم ({total})
                        </Typography>
                        <IconButton
                            color="inherit"
                            onClick={this.handleBackClick}
                            sx={{ position: "absolute", left: 10 }}
                        >
                            <ArrowBackIosNewIcon />
                        </IconButton>
                    </Toolbar>
                </AppBar>

                {/* Tabs */}
                <Box sx={{ borderBottom: 1, borderColor: 'divider', bgcolor: 'white' }}>
                    <Tabs 
                        value={activeTab} 
                        onChange={this.handleTabChange}
                        centered
                        sx={{
                            '& .MuiTab-root': {
                                fontSize: '16px',
                                fontWeight: 'bold'
                            }
                        }}
                    >
                        <Tab label="📦 قوائم جديدة" />
                        <Tab label="🔄 رواجع" />
                    </Tabs>
                </Box>

                {/* ✅ Search Box */}
                <Box sx={{ p: 2, bgcolor: 'white', display: 'flex', gap: 1, justifyContent: 'center' }}>
                    <TextField
                        placeholder="بحث برقم القائمة..."
                        value={search}
                        onChange={this.handleSearchChange}
                        onKeyPress={this.handleKeyPress}
                        size="small"
                        sx={{ width: 250 }}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <SearchIcon />
                                </InputAdornment>
                            ),
                        }}
                    />
                    <Button 
                        variant="contained" 
                        onClick={this.handleSearch}
                        sx={{ minWidth: 80 }}
                    >
                        بحث
                    </Button>
                    {search && (
                        <Button 
                            variant="outlined" 
                            color="error"
                            onClick={this.handleClearSearch}
                        >
                            مسح
                        </Button>
                    )}
                </Box>

                <Box p={3}>
                    {loading ? (
                        <Box textAlign="center" mt={5}>
                            <CircularProgress />
                            <Typography mt={2}>جاري التحميل...</Typography>
                        </Box>
                    ) : bills.length === 0 ? (
                        <Box textAlign="center" mt={5}>
                            <Typography variant="h6" color="textSecondary">
                                لا توجد قوائم
                            </Typography>
                        </Box>
                    ) : (
                        <>
                            <Grid container spacing={2}>
                                {bills.map(this.renderTable)}
                            </Grid>

                            {/* ✅ Pagination */}
                            {totalPages > 1 && (
                                <Box display="flex" justifyContent="center" mt={4}>
                                    <Pagination 
                                        count={totalPages} 
                                        page={page} 
                                        onChange={this.handlePageChange}
                                        color="primary"
                                        size="large"
                                        showFirstButton
                                        showLastButton
                                    />
                                </Box>
                            )}
                        </>
                    )}
                </Box>
            </Box>
        );
    }
}